import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fe385fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-index" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_Header = _resolveComponent("Header")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, null, {
      center: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_van_search, {
          modelValue: $setup.searchKeyword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKeyword) = $event)),
          shape: "round",
          "show-action": "",
          "left-icon": "",
          placeholder: "I'm looking for...",
          onSearch: $setup.onSearchValue,
          ref: "refsFocus",
          autofocus: ""
        }, {
          action: _withCtx(() => [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSearchValue($setup.searchKeyword)))
            }, "search")
          ]),
          _: 1
        }, 8, ["modelValue", "onSearch"])), [
          [_directive_focus]
        ])
      ]),
      _: 1
    }),
    _hoisted_1
  ], 64))
}